import { ui } from './class.ui';
import { inputHandler } from "./class.inputhandler";
import { sceneManager } from "./class.scenemanager";
import { palette } from "./class.palette";

class Triangoli {
    constructor(scene, assetsManager, tipo, parentMesh) {
        switch (tipo) {
            // modulo da 120
            case 1:
                this.task = assetsManager.addMeshTask("triangoli", "", "dist/assets/imports/", "cassa120/triangoli120.babylon");
                break;
            case 5:
                this.task = assetsManager.addMeshTask("triangoli", "", "dist/assets/imports/", "cassa180/anta180.babylon");
                break;
            case 6:
                this.task = assetsManager.addMeshTask("triangoli", "", "dist/assets/imports/", "cassa120orizzontale/anta120orizzontale.babylon");
                break;
            // modulo da 60
            default:
                this.task = assetsManager.addMeshTask("triangoli", "", "dist/assets/imports/", "cassa60/triangoli60.babylon");
        }
        this._scene = scene;
        this._parentMesh = parentMesh;
        this._meshes = [];

        this.task.onSuccess = (task) => {

            for (let j = 0; j < task.loadedMeshes.length; j++) {

                const triangle = task.loadedMeshes[j];
                this._meshes[j] = triangle;
                triangle._currentColor = palette._defaultTriangleColor;
                triangle.material = new BABYLON.StandardMaterial('mat' + j, this._scene);
                triangle.material.diffuseColor = palette.rgbToBabylon(triangle._currentColor);
                triangle.material.specularColor = new BABYLON.Color3(.2, .2, .2);
                triangle.parent = this._parentMesh;
                triangle.isPickable = true;
                triangle.renderOutline = sceneManager._showWireframe;
                triangle.outlineColor = new BABYLON.Color3(1, 1, 1);
                triangle.outlineWidth = .5;

                //HOVER
                triangle.actionManager = new BABYLON.ActionManager(this._scene);
                triangle.actionManager.registerAction(
                    new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, m => {
                        if ( !sceneManager._multiClickMode ) {
                            if (!inputHandler._isMouseDown) {
                                m.meshUnderPointer.material.diffuseColor = palette.rgbToBabylon(ui._selectedColor);
                            }
                        } else {
                            if (!inputHandler._isMouseDown) {
                                for (let j = 0; j < this._meshes.length; j++) {
                                    this._meshes[j].material.diffuseColor = palette.rgbToBabylon(ui._selectedColor);
                                }
                            }
                        }
                    })
                );
                triangle.actionManager.registerAction(
                    new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, m => {
                        if ( !sceneManager._multiClickMode ) {
                            m.meshUnderPointer.material.diffuseColor = palette.rgbToBabylon(m.meshUnderPointer._currentColor);
                        } else {
                            for (let j = 0; j < this._meshes.length; j++) {
                                this._meshes[j].material.diffuseColor = palette.rgbToBabylon(m.meshUnderPointer._currentColor);
                            }
                        }
                    })
                );

                //CLICK
                triangle.actionManager.registerAction(
                    new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickUpTrigger, m => {
                        if ( !sceneManager._multiClickMode ) {
                            if (inputHandler._isClickValid) {
                                const pickResult = this._scene.pick(this._scene.pointerX, this._scene.pointerY);

                                if (pickResult.hit) {
                                    pickResult.pickedMesh.material.diffuseColor = palette.rgbToBabylon(ui._selectedColor);
                                    pickResult.pickedMesh._currentColor = ui._selectedColor;
                                }
                            }
                        } else {
                            if (inputHandler._isClickValid) {
                                const pickResult = this._scene.pick(this._scene.pointerX, this._scene.pointerY);

                                if (pickResult.hit) {
                                    for (let j = 0; j < this._meshes.length; j++) {
                                        this._meshes[j].material.diffuseColor = palette.rgbToBabylon(ui._selectedColor);
                                        this._meshes[j]._currentColor = ui._selectedColor;
                                    }
                                }
                            }
                        }
                    })
                );
            }

            this._meshes.sort();
        }
    }

    toggleOutline(status) {
        for (let i = 0; i < this._meshes.length; i++) {
            let triangle = this._meshes[i];
            triangle.renderOutline = status;
        }
    }

    destroy() {
        this._meshes.map(mesh => {
            mesh.dispose();
        });
    }

    extractData() {
        let json = [];
        for (let i = 0; i < this._meshes.length; i++) {
            if ( this._meshes[i].name.lastIndexOf("anta", 0) !== 0) {
                json.push({ "indice": this._meshes[i].name, "colore": palette.rgbToName(this._meshes[i]._currentColor) });
            }
        }

        return json;
    }
}

export default Triangoli;
